import { Action, createReducer, on } from '@ngrx/store';

import { HEADER_STYLE, Header, HEADER_STYLES } from '@app/modules/core/header/entities/header-type';
import { setHeaderStyleAction } from '@app/modules/core/header/store/actions/header.actions';

export const initialState: Header = HEADER_STYLES.find(item => item.classType === HEADER_STYLE.BASIC);

const reducer = createReducer(
  initialState,
  on(setHeaderStyleAction, (state, { selection }) => {
    const stateColor = state.color;
    const selectionColor = selection.color;
    const headerStyles = { ...HEADER_STYLES.find(item => item.classType === selection.style) };
    return stateColor !== selectionColor ? {
      ...headerStyles,
      title: selection.title,
      color: selection.color,
      showTitle: selection.showTitle,
      previewColor: state.color
    } : {
      ...headerStyles,
      title: selection.title,
      color: selection.color,
      showTitle: selection.showTitle,
      previewColor: state.previewColor
    };
  })
);

export function headerStyleReducer(state: Header, action: Action): Header {
  return reducer(state, action);
}
